import { Stack, Title } from "@skailer-com/uikit";
import { ReactNode } from "react";

interface PreboardingSectionProps {
  title: string;
  children: ReactNode;
}

export function PreboardingSection({ title, children }: PreboardingSectionProps) {
  return (
    <Stack gap={"md"}>
      <Title header={title} size={"xs"} />
      <Stack gap={"sm"}>{children}</Stack>
    </Stack>
  );
}
